import PriceDelta from './PriceDelta';
import { withSek } from './worksheetFormatters';

const NewPrice = ({ price, delta }: { price: number; delta: number }) => (
    <div className="d-flex flex-column align-items-end gap-2">
        <span className={delta !== 0 ? 'semibold' : 'text-disabled'}>{withSek(price)}</span>
        {delta !== 0 && <PriceDelta delta={delta} />}
    </div>
);

export default NewPrice;
